import React, { useState } from 'react';
import './Contact.css';
import { FaLocationDot } from "react-icons/fa6";
import { FaPhoneAlt } from "react-icons/fa";
import { IoMdMail, IoLogoWhatsapp } from "react-icons/io";
import Forfmsubmit from "../Loader/Forfmsubmit";
import ManualAlertpage from '../Alert/ManualAlertpage';

const Contact = () => {

	// form submission 

	const [submissionpage, setsubmissionpage] = useState(false); // for enable Submission page 
	const [Submissiondata, setSubmissiondata] = useState({})

	const toggleFn = () => {
		setsubmissionpage(!submissionpage);
	}

	const [loader, setLoader] = useState(false);
	const [error, seterror] = useState("")
	const [data, setData] = useState({
		fullname: "",
		number: "",
		email: "",
		message: "",
	});

	const handleChange = (e) => {
		const { name, value } = e.target;
		setData({
			...data,
			[name]: value,
		});
	};

	const handleSubmitData = async (e) => {
		e.preventDefault();
		setLoader(true);
		seterror("")
		try {
			const response = await fetch("https://icoeess-backend-06-feb-2025-icoessbackend.onrender.com/api/contactmail", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(data),
			});

			const result = await response.json()
			if (response.ok) {
				setsubmissionpage(true)
				setSubmissiondata({
					message: "Thank you for Contacting us!!",
					context: `A confirmation E-mail has been sent on <strong>${data.email}</strong>. We will be in touch with you shortly.`,
					btnname: "Ok"
				})
				setData({
					fullname: "",
					number: "",
					email: "",
					message: ""
				})
			} else {
				seterror(result.message)
				console.error("Failed to send message, status code:", response.status);
			}
		} catch (err) {
			console.error("Error occurred during fetch:", err);
			seterror("Error occurred. Please try again later." + err.message);
		} finally {
			setLoader(false);
		}
	};

	if (loader) {
		return <Forfmsubmit />;
	}

	return (
		<section className="contact">
			<div className="content">
				<h2>Contact Us</h2>
				<p style={{ textAlign: "center" }}>Talk to us for your business needs, all staffing requirements, and anything on technology. We would love to hear from you & share our expertise with you.</p>
			</div>
			<div className="contact-page-container">
				<div className="contactInfo">
					<div className="box">
						<div className="icon"><FaLocationDot /></div>
						<div className="text">
							<h3>Address</h3>
							<p>Peptech Town<br />Chhatarpur(M.P.), India<br />471001</p>
						</div>
					</div>
					<div className="box">
						<div className="icon"><FaPhoneAlt /></div>
						<div className="text">
							<a href='tel:+919981810146'><h3>Phone</h3></a>
							<a href='tel:+919981810146'><p style={{ color: "black" }}>+91 9981810146</p></a>
						</div>
					</div>
					<div className="box">
						<div className="icon"><IoLogoWhatsapp /></div>
						<div className="text">
							<a href='https://wa.me/+919981810146' title='Chat with us' target='_blank'><h3>Whatsapp</h3></a>
							<a href='https://wa.me/+919981810146' title='Chat with us' target='_blank'><p style={{ color: "black" }}>+91 9981810146</p></a>
						</div>
					</div>
					<div className="box">
						<div className="icon"><IoMdMail /></div>
						<div className="text">
							<a href='mailto:info@icoesolution.com'><h3 >Email</h3></a>
							<a href='mailto:info@icoesolution.com'><p style={{ color: "black" }}>info@icoesolution.com</p></a>
						</div>
					</div>
					<h2 className="txt">Connect with us</h2>
				</div>

				<div className="contactForm">
					<form onSubmit={handleSubmitData}>
						<h2>Send Message</h2>
						<div className="inputBox">
							<input type="text" name="fullname" required onChange={handleChange} value={data.fullname} />
							<span>Full Name</span>
						</div>
						<div className="inputBox">
							<input type="number" name="number" required onChange={handleChange} value={data.number} />
							<span>Phone</span>
						</div>
						<div className="inputBox">
							<input type="email" name="email" required onChange={handleChange} value={data.email} />
							<span>Email</span>
						</div>
						<div className="inputBox">
							<textarea required name="message" onChange={handleChange} value={data.message}></textarea>
							<span>Type your Message...</span>
						</div>
						{error && <p className='error-textcontact'>{error}</p>}
						<div className="inputBox">
							<input type="submit" value={"Send"} />
						</div>
					</form>
				</div>
			</div>
			{submissionpage &&
				<ManualAlertpage
					message={Submissiondata.message}
					context={Submissiondata.context}
					context2={Submissiondata.context2}
					btnname={Submissiondata.btnname}
					close={submissionpage}
					togglebox={toggleFn} />
			}
		</section>
	);
};

export default Contact;
